export default __webpack_public_path__ + "static/media/navBack.e602cee9.svg";